module.exports = __webpack_public_path__ + "static/media/miwa_image.44c0b3ab.svg";